import { Controller } from "@hotwired/stimulus";
import jscolor from "@eastdesire/jscolor";

export default class extends Controller {
  static values = {
    color: { type: String, default: "#000000" },
  };
  connect() {
    if (!this.element.value) {
      this.element.value = this.colorValue;
    }

    if (!this.element.jscolor) {
      new jscolor(this.element, {});
    }
  }

  disconnect() {
    this.element.jscolor = null;
  }
}
